var map = {
	"./Arrow_Close.svg": "6679",
	"./Arrow_Next_Dark.svg": "4a2e",
	"./Arrow_Next_Light.svg": "9116",
	"./Arrow_Open.svg": "368f",
	"./Background_Recruit.png": "5658",
	"./Button_Link.png": "36dc",
	"./Button_Link_hover.png": "ed6d",
	"./arrow_works_left.svg": "3f79",
	"./arrow_works_right.svg": "fec1",
	"./badge_appstore@3x.png": "7f05",
	"./badge_googleplay@3x.png": "f103",
	"./button_close.svg": "4e2a",
	"./button_open.svg": "360f",
	"./coordinate@3x.png": "8ab2",
	"./coordinate_big@3x.png": "7e9e",
	"./dot.svg": "de15",
	"./facebook@2x.png": "2735",
	"./facebook@3x.png": "4151",
	"./fenrir_logo.svg": "3097",
	"./first_view_arrow.svg": "ce4e7",
	"./icn_App.png": "182e",
	"./icn_App@3x.png": "3aa7",
	"./icn_VR.png": "dcfb",
	"./icn_VR@3x.png": "094a",
	"./icn_check.png": "3fe1",
	"./icn_check@2x.png": "d508",
	"./icn_check@3x.png": "f811",
	"./icn_consulting.png": "a3c3",
	"./icn_consulting@3x.png": "12cc",
	"./icn_design.png": "8944",
	"./icn_design@3x.png": "9414",
	"./icn_first.svg": "ed35",
	"./icn_last.svg": "70bc",
	"./icn_left.svg": "db21",
	"./icn_miniprogram.png": "2bd6",
	"./icn_miniprogram@3x.png": "890b",
	"./icn_right.svg": "cc65",
	"./icn_tool.png": "d065",
	"./icn_tool@3x.png": "d932",
	"./icon_+.png": "e20d",
	"./icon_mail.png": "9287",
	"./icon_tel.png": "8852",
	"./icon_x.png": "c0df",
	"./img_map_pc@3x.png": "918e",
	"./img_map_sp@3x.png": "dd92",
	"./ise-woa/Flow_ISE@3x.png": "9268",
	"./ise-woa/Title_ISE1.png": "a34d",
	"./ise-woa/Title_ISE2.png": "680a",
	"./ise-woa/detail.png": "9615",
	"./kovax-miniapp/Flow_KOVAX@3x.png": "e83f",
	"./kovax-miniapp/Title_KOVAX1.png": "2cb3",
	"./kovax-miniapp/Title_KOVAX2.png": "e215",
	"./kovax-miniapp/detail.png": "7c15",
	"./kuraray-dx/Flow_kuraray_CN@3x.png": "048d",
	"./kuraray-dx/Flow_kuraray_JP@3x.png": "cae8",
	"./kuraray-dx/Minister.jpg": "249b",
	"./kuraray-dx/Title_kuraray1.png": "0b48",
	"./kuraray-dx/Title_kuraray2.png": "71b9",
	"./kuraray-dx/kuraray_PPT1_CN.jpg": "da37",
	"./kuraray-dx/kuraray_PPT1_JP.jpg": "1738",
	"./kuraray-dx/kuraray_PPT2_CN.jpg": "4810",
	"./kuraray-dx/kuraray_PPT2_JP.jpg": "13a3",
	"./kuraray-dx/kuraray_corporate_logo_rgb.svg": "ecca",
	"./new-pages/Management_PC_CN@3x.png": "6a07",
	"./new-pages/Management_PC_JP@3x.png": "30a6",
	"./new-pages/Network_Security@3x.png": "d5b8",
	"./new-pages/Network_Security_Table_CN@4x.png": "8f57",
	"./new-pages/Network_Security_Table_JP@4x.png": "15a0",
	"./new-pages/PC_CN.svg": "886b",
	"./new-pages/PC_JP.svg": "fe64",
	"./new-pages/SP_CN.svg": "79aa",
	"./new-pages/SP_JP.svg": "c936",
	"./new-pages/Security1_CN@3x.png": "3124",
	"./new-pages/Security1_JP@3x.png": "4433",
	"./new-pages/Security2_CN@3x.png": "2313",
	"./new-pages/Security2_JP@3x.png": "98b2",
	"./new-pages/Security3_CN@3x.png": "9ac4",
	"./new-pages/Security3_JP@3x.png": "1fa4",
	"./new-pages/Security4_CN@3x.png": "323e",
	"./new-pages/Security4_JP@3x.png": "8a70",
	"./new-pages/Technology_PC_CN@3x.png": "99f3",
	"./new-pages/Technology_PC_JP@3x.png": "da37b",
	"./new-pages/Title_Security_CN.png": "8b6f",
	"./new-pages/Title_Security_JP.png": "fe91",
	"./new-pages/Yostar@4x.png": "d75f",
	"./new-pages/Yostar_Alibaba_Logo@3x.png": "84b0",
	"./new-pages/Yostar_Logo@2x.png": "e9b1",
	"./new-pages/Yostar_User@2x.png": "c612",
	"./new-pages/Yostar_Websit_Bg@3x.png": "9636",
	"./new-pages/new_20231205_01.png": "1cd7",
	"./new-pages/new_20231205_02.png": "e5e7",
	"./office/cd_1021.jpg": "ffa6",
	"./office/sh_0924.jpg": "020f",
	"./official_accounts_website_1.png": "8cc0",
	"./official_accounts_website_2.png": "6dab",
	"./official_accounts_website_3.png": "0498",
	"./official_accounts_website_qrcode.png": "b16f",
	"./omission.svg": "610c",
	"./overseas-business-wechat-official-accounts_1.png": "c0fd",
	"./overseas-business-wechat-official-accounts_2.png": "f6b6",
	"./overseas-business-wechat-official-accounts_3.png": "fe090",
	"./overseas-business-wechat-official-accounts_4.png": "22c5",
	"./overseas-business-wechat-official-accounts_qrcode.png": "d4f5",
	"./shadow_left.png": "8353",
	"./shadow_right.png": "a680",
	"./square.jpg": "b5d4",
	"./twitter.svg": "a3df",
	"./wechat@2x.png": "3807",
	"./wechat@3x.png": "927d",
	"./wechat_code.jpg": "5678",
	"./weibo@2x.png": "fd83",
	"./weibo@3x.png": "c73c",
	"./works_beijing_xikemu_1.png": "0a59",
	"./works_beijing_xikemu_2.png": "0398",
	"./works_beijing_xikemu_3.jpg": "2f46",
	"./works_beijing_xikemu_4.jpg": "c894",
	"./works_beijing_xikemu_5.jpg": "b45d",
	"./works_beijing_xikemu_6.jpg": "85b5",
	"./works_beijing_xikemu_7.jpg": "d56c",
	"./works_feilang_go_1.png": "5bda",
	"./works_feilang_go_2.png": "6af6",
	"./works_feilang_go_3.png": "5781",
	"./works_feilang_go_4.png": "7c91",
	"./works_kuraray_miniapp_1.png": "e4b4",
	"./works_kuraray_miniapp_2.png": "ad95",
	"./works_kuraray_miniapp_3@1x.png": "0529",
	"./works_kuraray_miniapp_3@2x.png": "454c",
	"./works_kuraray_miniapp_3@3x.png": "aa4f",
	"./works_kuraray_miniapp_4@1x.png": "14b0",
	"./works_kuraray_miniapp_4@2x.png": "6a92",
	"./works_kuraray_miniapp_4@3x.png": "18c7",
	"./works_kuraray_miniapp_5.jpg": "1cf1",
	"./works_kuraray_miniapp_6.jpg": "017b",
	"./works_mixi_xflag_1.png": "1116",
	"./works_mixi_xflag_2.png": "66ee",
	"./works_mixi_xflag_3.png": "7790",
	"./works_mixi_xflag_4.png": "c42e",
	"./works_nikkei_telecon_1.png": "8762",
	"./works_nikkei_telecon_2.png": "d6ef",
	"./works_nikkei_telecon_3.png": "dd40",
	"./works_nikkei_telecon_4.png": "8530",
	"./works_rakuten_gora_1.png": "caa6",
	"./works_rakuten_gora_2.png": "18fa",
	"./works_rakuten_gora_3.png": "8b51",
	"./works_rakuten_gora_4.png": "3071",
	"./works_wechat_anpi_1.png": "a38e",
	"./works_wechat_anpi_2.png": "a018",
	"./works_wechat_anpi_3.png": "acfd",
	"./works_wechat_anpi_4.png": "218a",
	"./works_xikemu_dx_1.png": "fa44",
	"./works_xikemu_dx_2.png": "2177",
	"./works_xikemu_dx_3.jpg": "73e7",
	"./works_xikemu_dx_4.jpg": "1b86",
	"./works_xikemu_dx_5.jpg": "e8d3",
	"./works_xikemu_dx_6.jpg": "c565",
	"./works_xikemu_dx_7.jpg": "becb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";